/**
 * Cloud-app–linked units: normalize `cloudApp` from Firestore (string, object, or array).
 */
export function normalizeCloudAppValues(input) {
  if (input === null || input === undefined) return [];

  if (Array.isArray(input)) {
    return input.flatMap(normalizeCloudAppValues);
  }

  if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    const normalized = String(input).trim();
    return normalized ? [normalized] : [];
  }

  if (typeof input === 'object') {
    const preferred =
      input.id ??
      input.name ??
      input.key ??
      input.cloudApp ??
      input.cloudAppId ??
      input.provider;
    if (preferred !== undefined && preferred !== null) {
      return normalizeCloudAppValues(preferred);
    }
    return [];
  }

  return [];
}

export function unitCloudAppValues(value) {
  const values = normalizeCloudAppValues(value?.cloudApp);
  return [...new Set(values)];
}

export function getTrimmedCloudAppUrl(unitData) {
  const u = typeof unitData?.cloudAppURL === 'string' ? unitData.cloudAppURL.trim() : '';
  return u || null;
}

/** Unit opens the embedded portal when `cloudAppURL` is set (optional `cloudApp` labels the tab). */
export function isCloudAppPortalUnit(unitData) {
  return !!getTrimmedCloudAppUrl(unitData);
}

export function cloudAppPortalTabLabel(unitData) {
  const apps = unitCloudAppValues(unitData);
  const name = apps[0] || 'Cloud app';
  return `${name} Portal`;
}

export function cloudAppPortalPath(dataID) {
  return `/dashboard/${dataID}/portal`;
}

export function unitManagementPath(dataID) {
  return `/dashboard/${dataID}/management`;
}

/** Default fallback when leaving dashboard pages (no template page, errors, etc.). */
export function defaultUnitFallbackPath(dataID, unitData) {
  if (isCloudAppPortalUnit(unitData)) {
    return cloudAppPortalPath(dataID);
  }
  return unitManagementPath(dataID);
}
